export default "__VITE_ASSET__$Z7odDs7__"